import { usePageMeta } from "@/hooks/usePageMeta";
import { categories } from "@/mocks/categories";
import {
  getFeaturedVideos,
  getHotVideos,
  getVideosByCategory,
  sortVideos,
} from "@/utils/videoHelpers";
import VideoCard from "@/components/feature/VideoCard";
import SectionHeading from "@/components/feature/SectionHeading";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";

export default function Home() {
  usePageMeta({
    title: "91短视频-热门短视频平台在线观看与分享",
    description:
      "91短视频提供丰富多彩的短视频内容，包括搞笑、娱乐、生活、美食等多类别，用户可以在线观看、分享和评论，享受轻松愉快的短视频体验。",
    keywords:
      "91短视频,短视频,热门短视频,短视频平台,视频分享,娱乐短视频,搞笑短视频,生活短视频",
  });

  const featured = getFeaturedVideos();
  const hot = getHotVideos(8);

  return (
    <div className="w-full">
      <HeroCarousel videos={featured} />
      <CategoryEntries />

      <section className="mx-auto w-full max-w-7xl px-4 pb-4 md:px-6">
        <SectionHeading
          title="热门推荐"
          subtitle="全站播放量最高的短视频，大家都在看"
          icon="ri-fire-line"
          moreTo="/search"
          moreLabel="去发现更多"
        />
        <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-5 lg:grid-cols-4">
          {hot.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </section>

      {categories.map((category, index) => {
        const list = sortVideos(getVideosByCategory(category.key), "latest").slice(0, 6);
        return (
          <section
            key={category.slug}
            className={`w-full py-10 md:py-12 ${
              index % 2 === 1 ? "bg-background-100" : "bg-background-50"
            }`}
          >
            <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
              <SectionHeading
                title={`${category.name}短视频`}
                subtitle={category.description}
                icon={category.icon}
                moreTo={`/category/${category.slug}`}
              />
              <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-5">
                {list.map((video) => (
                  <VideoCard key={video.id} video={video} />
                ))}
              </div>
            </div>
          </section>
        );
      })}
    </div>
  );
}